import { Check } from "@mui/icons-material";
import {
    Box,
    Chip,
    InputAdornment,
    IconButton,
    Paper,
    PaperProps,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import { useState } from "react";

interface SkillsProps {
    skills: string[];
    setSkills: React.Dispatch<React.SetStateAction<string[]>>;
    editMode: boolean;
    paperProps?: PaperProps;
}

const Skills = ({
    skills,
    setSkills,
    editMode,
    paperProps,
}: SkillsProps) => {
    const [newSkill, setNewSkill] = useState('');

    const handleSkillRemove = (skillToRemove: string) => {
        setSkills(skills.filter(skill => skill !== skillToRemove));
    };

    const onEnter = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e?.key === 'Enter' && newSkill.trim()) {
            handleAddSkill();
        };
    };

    const handleAddSkill = () => {
        if (!skills.includes(newSkill.trim())) {
            setSkills([...skills, newSkill.trim()]);
        }
        setNewSkill('');
    };

    return (
        <Paper {...paperProps} sx={{ padding: 2, mb: 3, borderRadius: 2, ...paperProps?.sx }}>
            <Stack gap={1}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                    <Typography variant="h6">Skills</Typography>
                </Box>

                {editMode && (
                    <TextField
                        size="small"
                        placeholder="Add a skill"
                        value={newSkill}
                        onChange={(e) => setNewSkill(e.target.value)}
                        onKeyDown={onEnter}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        edge="end"
                                        onClick={handleAddSkill}
                                        disabled={!newSkill.trim()}
                                    >
                                        <Check fontSize="small" sx={{ color: newSkill.trim() ? "success.main" : "text.secondary" }} />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                )}

                <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
                    {Array.isArray(skills) && skills.length > 0 ? (
                        skills.map((skill, index) => (
                            <Chip
                                key={index}
                                label={skill}
                                onDelete={editMode ? () => handleSkillRemove(skill) : undefined}
                                color="primary"
                                variant="filled"
                            />
                        ))
                    ) : (
                        <Typography color="text.secondary">No skills added yet</Typography>
                    )}
                </Stack>
            </Stack>
        </Paper>
    );
};

export default Skills; 